import { TaxiCompanyApiTaxiCopmpanyCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiCompanyCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiCompanyApiTaxiCopmpanyCreateRequest, config) =>
      appApiClient.taxiCompanyApi.taxiCopmpanyCreate(req, config),
  });
